import { FailIcon, SuccessIcon } from "../Icons";
import styles from "./ConclusionFlag.module.css";

type ComponentProps = {
  isSuccess: string | undefined;
  successLabel?: string;
  failureLabel?: string;
}
const ConclusionFlag = ({ isSuccess, successLabel = "", failureLabel = "" }: ComponentProps) => {
  if (isSuccess === "yes") {
    return (
      <span className={[styles.flag, styles.success].join(" ")}>
        <SuccessIcon />
        {successLabel ? ` ${successLabel}` : ""}
      </span>
    );
  }

  if (isSuccess === "no") {
    return (
      <span className={[styles.flag, styles.failure].join(" ")}>
        <FailIcon />
        {failureLabel ? ` ${failureLabel}` : ""}
      </span>
    );
  }

  return null;
};

export default ConclusionFlag;
